import AnalysisCategory from 'views/Analysis/AnalysisCategory';
import { AnalysisKinds, ComparisonKinds } from 'views/Analysis/analysisUtils';

// 分析（受注区分）
function AnalysisJuchuKbn(props) {
  // 分析情報
  const analysisList = props.quoteList;
  // 選択中の期
  const selectedPeriod = props.selectedPeriod;
  // 分析種別
  const analysisKind = AnalysisKinds.find((x) => x.key == props.analysisKind);
  // 比較種別
  const comparisonKind = ComparisonKinds.find((x) => x.key == props.comparisonKind);

  // 集計項目
  const summaryItems = [
    { key: 'JUCHU_KBN_1', label: '設計をともなう営業' },
    { key: 'JUCHU_KBN_2', label: '見積のみ営業' },
    { key: 'JUCHU_KBN_3', label: '年間管理' },
    { key: 'JUCHU_KBN_9', label: 'はるな墓苑' },
  ];

  return (
    <>
      <div>設計をともなう営業……「新築」、「リフォーム」</div>
      <div>見積のみ営業……………「小工事」、「スポット管理」</div>
      <AnalysisCategory
        analysisList={analysisList}
        selectedPeriod={selectedPeriod}
        summaryItems={summaryItems}
        analysisKind={analysisKind}
        comparisonKind={comparisonKind}
        categoryName="受注区分別"
      />
    </>
  );
}
export default AnalysisJuchuKbn;
